import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { ConsentJSONAModel } from "interfaces/jsona-models/ConsentJSONAModel";

export class ConsentSelector extends BaseApiSelector<ConsentJSONAModel> {
  constructor() {
    super(ResourceType.Consent);
  }
}
